import React, { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { _ } from "../../functions/translator";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { dayChange } from "../../actions";
import TextField from '@material-ui/core/TextField';
import { previousMonth } from "../../functions/utils";

const DayTimeCalendar = (props) => {
  const [firstDate, setFirstDate] = useState(props.day.first);
  const [lastDate, setLastDate] = useState(props.day.last);
  const firstDatePickerRef = useRef();
  const secondDatePickerRef = useRef();

  useEffect(() => {
    setFirstDate(props.day.first)
    setLastDate(props.day.last)
  }, [props.day])

  const handleFirstChange = (event) => {
    const date = new Date(event.target.value).toISOString().split('T')[0]
    setFirstDate(date)
    props.dayChange({...props.day, first: date})
  }

  const handleLastChange = (event) => {
    const date = new Date(event.target.value).toISOString().split('T')[0]
    setLastDate(date)
    props.dayChange({...props.day, last: date})
  }

  const minDate = props.projectData.days[0].id
  const maxDate = props.projectData.days[props.projectData.days.length - 1].id

  return (
    <div className="w-100 d-flex flex-column">
      <div className="ml-2">
        <p className="mb-1">{_('Desde')}:</p>
        <TextField
            type="date"
            ref={firstDatePickerRef}
            value={firstDate}
            onChange={(date) => handleFirstChange(date)}
            variant='outlined'
            inputProps={{
                min: minDate,
                max: maxDate
            }}
            InputLabelProps={{
                shrink: true
            }}
            sx={{ margin: 0 }}
            style={{margin: '10px 0px'}}
        />
      </div>
      <div className="ml-2">
        <p className="mb-1">{_('Hasta')}:</p>
        <TextField
            type="date"
            ref={secondDatePickerRef}
            value={lastDate}
            onChange={(date) => handleLastChange(date)}
            variant='outlined'
            inputProps={{
                min: minDate,
                max: maxDate
            }}
            InputLabelProps={{
                shrink: true
            }}
            sx={{ margin: 0 }}
            style={{margin: '10px 0px'}}
        />
      </div>
    </div>
  );
};

function mapStateToProps( state ){
    return {
        day         : state.day,
        projectData : state.projectData
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        dayChange    : dayChange,
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(DayTimeCalendar);
